import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

class GrowthbookAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.EXPERIMENT)
  }

  public viewedExperiment(experiment_id: string, variation_id: number): void {
    this.logEvent({
      event: 'experiment_viewed',
      experiment_id,
      variation_id,
    })
  }
}

export default new GrowthbookAnalytics()
